export const IMAGE_PLACEHOLDER_FULL_ID = 'plugins/Basic/assets/placeholder.svg';
